import React, { useEffect } from 'react'

import ContentArea from 'Components/ContentArea'

const LandingPage = ({ data, inEditMode }) => {
  const { MainContentArea, HomepageStaticH1 } = data
  return (
    <>
      <h1 className='sr-only'>{HomepageStaticH1 ?? 'Wellby Financial | Houston Federal Credit Union'}</h1>
      <ContentArea data={MainContentArea} name="MainContentArea" inEditMode={inEditMode} />
    </>
  )
}

export default React.memo(LandingPage)
